// Remember:
// Every file in scripts/ acts as an entry-point and gets tranformed to build/. Feel free to create as much as you want.
// Files in subdirectories will be ignored but you can require them in entry-point-files.
// Add an _ to a file and it will just be ignored(good for tests).
// Add your entry-point-files to templates/layout/yourlayout.html




//=require ../../patterns/atoms/select/select.js

//=require ../../patterns/molecules/textrow/textrow.js
//=require ../../patterns/molecules/gallery/gallery.js
//=require ../../patterns/molecules/team/team.js
//=require ../../patterns/molecules/accordion/accordion.js
//=require ../../patterns/molecules/carousel/carousel.js
//=require ../../patterns/molecules/slideshow/slideshow.js
//=require ../../patterns/molecules/tabs/tabs.js
//=require ../../patterns/molecules/lightbox/lightbox.js
//=require ../../patterns/molecules/forms/forms.js

//=require ../../patterns/organisms/hero/hero.js
//=require ../../patterns/organisms/facebookstream/facebookstream.js
//=require ../../patterns/organisms/einrichtungssuche/einrichtungssuche.js
//=require ../../patterns/organisms/jobfair/jobfair-latest.js
//=require ../../patterns/organisms/searchform/searchform.js

//=require ../../patterns/organisms/navigation/navigation_2021.js
//=require ../../patterns/organisms/header/header_2021.js




// Development helper

document.addEventListener(
    'focus',
    function () {
        console.log('focused: ', document.activeElement);
    },
    true
);

const videos = document.querySelectorAll('.video');
for (const video of videos) {
    let playButton = video.querySelector('.video__play');
    let videoPreview = video.querySelector('.video__preview');
    playButton.addEventListener( 'click', function(e){
        let iframe = document.createElement('iframe');
        iframe.src = playButton.dataset.embedSrc;
        if (!video.classList.contains('video--in-slider')) {
            iframe.src = iframe.src + '&autoplay=1';
        }
        iframe.title = playButton.dataset.embedTitle;
        iframe.setAttribute('allow', 'fullscreen; autoplay');
        videoPreview.replaceWith(iframe);
    });
}

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    );
}


const legalinfo = document.querySelector('.legalinfo');
const stickyBtn = document.querySelector('.sticky-btn');

document.addEventListener('scroll', function () {
   if (isInViewport(legalinfo)) {
       stickyBtn?.classList.add('high');
   } else {
       stickyBtn?.classList.remove('high');
   }
}, {
    passive: true
});

const stickyButtons = document.querySelectorAll('[data-sticky-button]');
for (const button of stickyButtons) {
    const panel = button.nextElementSibling;

    const setExpanded = (expanded) => {
        button.ariaExpanded = expanded ? 'true' : 'false';
        panel.tabIndex = expanded ? 0 : -1;
    };

    button.addEventListener('click', () => {
        setExpanded(button.ariaExpanded !== 'true');
    });

    button.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && button.ariaExpanded === 'true') {
            setExpanded(false);
        }
    });

    panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && button.ariaExpanded === 'true') {
            setExpanded(false);
            button.focus();
        }
    });
}